<template>
    <div class="invoicesForm">
        <van-nav-bar title="发票信息" left-arrow @click-left="onClickLeft" />
        <div>
            <p class="invoices-tip">发票将发送至您的电子邮箱，请保证邮箱填写正确</p>
            <div class="invoice-content">
                <van-form @submit="onSubmit" ref="submitForm">
                    <van-field name="invoiceType" label="发票类型">
                        <template #input>
                            <van-radio-group v-model="form.invoiceType" direction="horizontal" @change="handleType()">
                                <van-radio name="1" class="mr-4">普通发票</van-radio>
                                <van-radio name="2" class="romSty">增值税专用发票</van-radio>
                            </van-radio-group>
                        </template>
                    </van-field>

                    <van-field name="form.invoiceTitleType" label="抬头类型">
                        <template #input>
                            <van-radio-group
                                v-model="form.invoiceTitleType"
                                direction="horizontal"
                                @change="resetValidation"
                            >
                                <van-radio name="2" :disabled="form.invoiceType == 2" class="mr-4">个人</van-radio>
                                <van-radio name="1" class="romSty">单位</van-radio>
                            </van-radio-group>
                        </template>
                    </van-field>
                    <van-field
                        v-model="form.invoiceContent"
                        label="发票内容"
                        readonly
                        maxlength="25"
                        class="invoiceContent"
                    />
                    <van-field
                        v-model="form.invoiceAmount"
                        label="发票金额"
                        clearable
                        maxlength="25"
                        class="invoiceAmount"
                    >
                        <span slot="extra">元</span>
                    </van-field>
                    <van-field
                        v-model="form.invoiceTitle"
                        v-if="form.invoiceTitleType == 2"
                        label="姓名"
                        placeholder="请填写开票人姓名"
                        maxlength="25"
                        :rules="[{ validator, message: '' }]"
                    />
                    <van-field
                        v-model="form.idCard"
                        v-if="form.invoiceTitleType == 2"
                        label="身份证号"
                        placeholder="请填写开票人身份证号"
                        maxlength="25"
                        :rules="[{ validator: idNumberValidator, message: '' }]"
                    />
                    <van-field
                        v-model="form.invoiceTitle"
                        label="单位名称"
                        placeholder="请填写单位名称"
                        maxlength="25"
                        v-if="form.invoiceTitleType == 1"
                        :rules="[{ validator, message: '' }]"
                    />
                    <van-field
                        v-model="form.taxNumber"
                        label-width="100px"
                        label="纳税人识别号"
                        placeholder="请填写纳税人识别号"
                        maxlength="25"
                        v-if="form.invoiceTitleType == 1"
                        :rules="[{ validator, message: '' }]"
                    />
                    <van-field
                        v-model="form.recipientEmail"
                        label="电子邮箱"
                        placeholder="请填写收件人邮箱"
                        maxlength="25"
                        :rules="[{ validator: validateEmail, message: '' }]"
                    />
                    <van-field
                        v-model="form.bankName"
                        label="开户银行"
                        placeholder="请填写开户银行（非必填）"
                        maxlength="25"
                        v-if="form.invoiceTitleType == 1"
                    />
                    <van-field
                        v-model="form.bankAccount"
                        label="银行账号"
                        placeholder="请填写银行账号（非必填）"
                        v-if="form.invoiceTitleType == 1"
                        maxlength="25"
                    />
                    <van-field
                        v-model="form.registPhone"
                        label="注册电话"
                        placeholder="请填写注册电话（非必填）"
                        type="text"
                        v-if="form.invoiceTitleType == 1"
                        maxlength="15"
                    />
                    <van-field
                        v-model="form.registAdress"
                        label="注册地址"
                        placeholder="请填写注册地址（非必填）"
                        v-if="form.invoiceTitleType == 1"
                        maxlength="50"
                    />
                    <div class="submitBtn">
                        <van-button round block type="info" native-type="submit">提交</van-button>
                    </div>
                </van-form>
            </div>
        </div>
        <van-dialog
            v-model="dialogShow"
            title=""
            show-cancel-button
            class="errorTip"
            confirmButtonText="确定"
            cancelButtonText="取消"
            @confirm="handleConfirm()"
        >
            <img src="../../../assets/images/account/errorTip.png" />
            <p class="tip-title">提示</p>
            <p class="tip-text">{{ text1 }}</p>
        </van-dialog>
    </div>
</template>

<script>
import { Toast } from 'vant'
export default {
    name: 'invoicesform',
    data() {
        return {
            dialogShow: false,
            text1: '已填写信息将不被保存，是否返回',
            form: {
                invoiceType: '1', //发票类型 1普通发票 2增值税专用发票
                invoiceTitleType: '2', //抬头类型 1单位 2个人
                invoiceTitle: '', // 发票抬头
                invoiceContent: '', // 发票内容
                invoiceAmount: '', // 金额
                taxNumber: '',
                bankName: '',
                bankAccount: '',
                registPhone: '',
                recipientPhone: '',
                recipientEmail: '',
                orderId: 0
            }
        }
    },
    created() {
        const { id, invoiceAmount, invoiceContent } = this.$route.query
        this.form.orderId = id
        this.form.invoiceAmount = invoiceAmount
        this.form.invoiceContent = invoiceContent
    },
    methods: {
        idNumberValidator(val) {
            // 身份证号码为15位或者18位，15位时全为数字，18位前17位为数字，最后一位是校验位，可能为数字或字符X
            return /(^\d{15}$)|(^\d{18}$)|(^\d{17}(\d|X|x)$)/.test(val)
        },
        validator(val) {
            return !/^\s*$/g.test(val)
        },
        validatePhone(val) {
            return /^1(?:3[0-9]|4[5-9]|5[0-9]|6[12456]|7[0-8]|8[0-9]|9[0-9])[0-9]{8}$/.test(val)
        },
        validateTel(val) {
            return (
                /^1(?:3[0-9]|4[5-9]|5[0-9]|6[12456]|7[0-8]|8[0-9]|9[0-9])[0-9]{8}$/.test(val) ||
                /^0[1-9][0-9]{1,2}-[2-8][0-9]{6,7}$/.test(val)
            )
        },
        validateEmail(val) {
            if (val) {
                return /\w+([-+.]\w+)*@\w+([-.]\w+)*\.\w+([-.]\w+)*/.test(val)
            } else {
                return false
            }
        },
        resetValidation() {
            this.$refs.submitForm.resetValidation()
        },
        onClickLeft() {
            this.text1 = '已填写信息将不被保存，是否返回'
            this.dialogShow = true
        },
        // 发票类型
        handleType() {
            if (this.form.invoiceType == 2) {
                this.form.invoiceTitleType = '1'
            }
        },

        handleConfirm() {
            if (this.text1 == '提交后发票信息将无法更改') {
                this.submitData()
            } else {
                this.$router.go(-1)
            }
        },
        onSubmit(values) {
            this.dialogShow = true
            this.text1 = '提交后发票信息将无法更改'
        },
        submitData() {
            const that = this
            this.$api.invoice.postData(this.form).then(res => {
                if (res.code == 0) {
                    Toast({
                        message: '申请成功',
                        type: 'success',
                        className: 'successTY',
                        onClose: function () {
                            that.$router.push({
                                path: '/orderpage'
                            })
                        }
                    })
                } else {
                    Toast.fail(res.data.message)
                }
            })
        }
    }
}
</script>

<style scoped lang="stylus">
@import '../asset/css/invoices.styl'
.successTY{
    background:rgba(0,0,0,.7);
}
</style>

<style lang="less" scoped>
.invoice-content {
    /deep/ .invoiceAmount {
        .van-field__body {
            margin-right: 4px;
            .van-field__control {
                color: red;
            }
        }
    }
    /deep/ .invoiceContent {
        .van-field__body {
            .van-field__control {
                overflow: hidden;
                text-overflow: ellipsis;
                white-space: nowrap;
            }
        }
    }
}
</style>
